export const getUserAge = (birthDateString: string, today: Date = new Date()) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birthDateString);
  if (!match) return 0;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);

  let age = today.getFullYear() - year;
  const hasHadBirthdayThisYear =
    today.getMonth() + 1 > month ||
    (today.getMonth() + 1 === month && today.getDate() >= day);

  if (!hasHadBirthdayThisYear) {
    age--;
  }

  return age;
}

export const getFieldTag = (type?: string) => {
  if (type === 'textarea') {
    return 'textarea';
  }

  if (type === 'select') {
    return 'select';
  }

  return 'input';
}

export const maxDate = (today: Date = new Date()) => {
  const year = today.getFullYear() - 16;
  const month = String(today.getMonth() + 1).padStart(2, '0'); 
  const day = String(today.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};